<template>
  <v-data-table
    :search="search"
    :headers="headers"
    :items="items"
    loading-text="Загрузка..."
    no-data-text="Пусто"
    no-results-text="Результатов нет"
    @click:row="onClickRow"
    :item-class="item => item.deleted ? 'deleted clickable-row' : 'clickable-row'"
    :options.sync="options_model"
    :server-items-length="total"
  >
    <template #top>
      <div class="d-flex ma-2">
        <v-row align="end" justify="space-between" no-gutters>
          <v-col cols="12" sm="12" md="8">
            <slot name="add">
              <v-btn class="mr-2" color="primary" dark @click="$emit('onAdd')">
                <v-icon>mdi-plus</v-icon>
                Добавить
              </v-btn>
            </slot>
            <v-btn
              color="green" dark
              @click="options.include_deleted = !options.include_deleted"
            >
              <span>
                {{ showingDeleted ? 'Скрыть удаленные' : 'Показать удаленные' }}
              </span>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="4" v-if="searchable">
            <TextField v-model="search" append-icon="mdi-magnify" label="Поиск" class="pt-0"/>
          </v-col>
        </v-row>
      </div>
    </template>

    <template #item.enabled="props">
      <v-icon>
        {{ props.item.enabled ? 'mdi-check' : 'mdi-close' }}
      </v-icon>
    </template>
    <slot/>
  </v-data-table>
</template>

<script>
import TextField from './TextField.vue';
import debounce from 'lodash.debounce';

export default{

  props: {
    items: Array,
    headers: Array,
    options: {
      type: Object,
      default:() => {return {}}
    },
    total: Number,
    searchable: Boolean
  },

  data: () => ({
    search:''
  }),

  computed:{
    options_model: {
      set(v){
        this.$emit('updateOptions', v);
      },
      get(){
        return this.options;
      }
    },

    showingDeleted(){
      return this.options_model.include_deleted;
    }
  },

  methods: {
    onClickRow(item){
      this.$emit('onClickRow', item);
    },

    onSearch(query){
      this.$emit('onSearch', query);
    }
  },

  watch:{
    options: {
      handler(){
        this.$emit('filtered');
      },
      deep: true
    },

    search(val){
      this.debounceSearch(val)
    }
    
  },

  created(){
    this.debounceSearch = debounce((newVal) => {
      this.onSearch(newVal);
    }, 600);
  },

  beforeUnmount() {
    this.debouncedWatch.cancel();
  },

  components:{
    TextField
  }
}
</script>

<style>
.deleted {
  background-color: #e5d4d4;
}
</style>